module.exports = __webpack_public_path__ + "static/media/x.7d2a01fd.svg";